import { useState, useMemo } from 'react';
import { Popover, PopoverTrigger, PopoverContent } from '@leadsnavi/ui-kit';
import EmojiPicker from '@emoji-mart/react';
import data from '@emoji-mart/data';
import * as EditorTypeAll from '../tinymce.d';
import { Smile } from 'lucide-react';
import type { EmojiMartData } from '@emoji-mart/data';

interface Props {
  editorInstance: EditorTypeAll.Editor;
}

const Emoji = ({ editorInstance }: Props) => {
  const [visible, setVisible] = useState(false);

  // 过滤掉 id 为 "crossed_flags" 的 emoji
  const filteredData = useMemo(() => {
    const excludedEmojiId = 'crossed_flags';
    const emojiData = data as EmojiMartData;
    const filteredCategories = emojiData.categories.map((category) => ({
      ...category,
      emojis: category.emojis.filter((emojiId) => emojiId !== excludedEmojiId),
    }));

    const { [excludedEmojiId]: excludedEmoji, ...filteredEmojis } = emojiData.emojis;

    return {
      ...emojiData,
      categories: filteredCategories,
      emojis: filteredEmojis,
    };
  }, []);

  const onEmojiSelect = (val: { native: string }) => {
    console.log('onEmojiSelect', val);
    // 先插入表情内容
    editorInstance.insertContent(val.native);
    // 插入后检查内容是否为空，如果不为空则清除 placeholder
    // 使用 setTimeout 确保内容已插入到 DOM 中，并且编辑器的事件处理完成
    setTimeout(() => {
      const body = editorInstance.getBody();
      if (body) {
        // 检查内容是否为空：textContent 可以正确获取表情等 Unicode 字符
        const textContent = body.textContent || '';
        // 如果内容不为空（包括表情），则清除 placeholder
        if (textContent.trim().length > 0) {
          editorInstance.fire('setPlaceHolder', { value: null });
        }
      }
    }, 0);
    setVisible(false);
  };
  return (
    <Popover open={visible} onOpenChange={setVisible} modal={false}>
      <PopoverTrigger asChild>
        <div className="inline-flex p-1.5 rounded-[4px] cursor-pointer hover:bg-[#E5E5E5]">
          <Smile strokeWidth={1.5} size={18} />
        </div>
      </PopoverTrigger>
      <PopoverContent side="top" sideOffset={5} style={{ zIndex: 9999 }} className="p-0">
        {visible ? (
          <EmojiPicker
            data={filteredData}
            theme="light"
            searchPosition="none"
            previewPosition="none"
            visible={visible}
            onEmojiSelect={onEmojiSelect}
          />
        ) : undefined}
      </PopoverContent>
    </Popover>
  );
};

export default Emoji;
